import { initialState } from "./initial-state.js";
import { getPosts } from "./thunks/get-posts.js";
import { createSlice } from "@reduxjs/toolkit";
var slice = createSlice({
	name: "posts",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getPosts.pending, (state) => {
			state.isPending = true;
			state.isRejected = false;
			state.errorMessage = "";
		}).addCase(getPosts.fulfilled, (state, action) => {
			state.posts = action.payload;
			state.isPending = false;
			state.isRejected = false;
		}).addCase(getPosts.rejected, (state, action) => {
			state.isPending = false;
			state.isRejected = true;
			state.errorMessage = action.error.message ?? "";
		});
	}
});
slice.actions;
var reducer = slice.reducer;
//#endregion
export { reducer, slice };

//# sourceMappingURL=slice.js.map